<div class="soon-page">
    <div class="soon-page__top" [className]='type' id="imagen">
    </div>
    <div class="soon-page__bottom">
        <span class="title">{{title}}</span>
        <span class="description">{{description}}</span>
    </div>
</div>